/**
 * The public URL of one research project: `/cercetare/<slug>`.
 *
 * Same shape as eventPath.ts / forumPath.ts / providerPath.ts: the slug comes straight from the
 * API, assigned once when the project is filed and never recomputed, so a link stays valid after
 * the title is corrected.
 *
 * Falls back to the id when a caller has one without a slug — a result whose project is not itself
 * published carries `projectSlug: null`, and so does any row served by a backend that predates the
 * slug column. `/cercetare/:slug` resolves either form, so the fallback is a working address
 * rather than a broken one.
 */
export function projectPath(project: { slug?: string | null; id: string }): string {
  return `/cercetare/${project.slug || project.id}`;
}
